import { createOffer, getUsersSql } from "@/api/offer";
import Vue from "vue";

const state = {
  users: {},
};

const mutations = {
  SET_USERS(state, users) {
    state.users = users;
  },
};

const actions = {
  async getUsersSql({ commit }, payload) {
    try {
      const response = await getUsersSql(payload);
      if (response && response.code === 200 && response.data) {
        commit("SET_USERS", response.data);
        return response;
      } else {
        throw response.message;
      }
    } catch (e) {
      Vue.$toast.error(e, {
        duration: 0,
      });
    }
  },
  async createOffer(_, field) {
    return await createOffer(field);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
